import { HurricaneLandingPageLazy } from './hurricaneLandingPageLazy';

const props = [];

export const HurricaneLandingPageDirective = reactDirective => reactDirective(HurricaneLandingPageLazy, props);
HurricaneLandingPageDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('hurricaneLandingPage', HurricaneLandingPageDirective);
